import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import moment from 'moment-timezone';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import BatchExecutionDetailsModalContent from './Components/BatchExecutionDetailsModalContent';

import './BatchExecutionDetailsModal.scss';

const spinnerId = `rx-search-batch-file-execution-details${uuid()}`;

function BatchExecutionDetailsModal(props) {
  const { init, cancel, isLoading } = props;
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initDate = Date.now();

  const header = (
    <div className="batch-execution-details-modal__header">
      <h4>Batch Query Log File</h4>
      <h4>{`Date: ${moment(initDate).format('ddd D MMM YYYY, H:mm')}`}</h4>
    </div>
  );

  return (
    <GeneralDialogLayout
      {...props}
      selfClose={cancel}
      className="batch-execution-details-modal"
      size="xl"
      header={header}
      footerClassName="rx-border-none">
      {isLoading ? <SimpleSpinner id={spinnerId} /> : <BatchExecutionDetailsModalContent {...props} />}
    </GeneralDialogLayout>
  );
}

BatchExecutionDetailsModal.propTypes = {
  init: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default BatchExecutionDetailsModal;
